<template>
  <div class="items">
    <div class="item_body_date">
      {{ outputDate(item.typeDoneDate) | dateText('YYYY.MM.DD') }}
    </div>
    <div class="item_body_keyword">
      <template v-if="item.type === 'rewrite'">
        キーワード「{{
          item.keyword
        }}」のコンテンツをリライトして1ヶ月が経ちました。施策の効果を確認しましょう。
      </template>
      <template v-if="item.type === 'changeTd'">
        キーワード「{{
          item.keyword
        }}」のコンテンツをタイトル変更して1ヶ月が経ちました。施策の効果を確認しましょう。
      </template>
    </div>

    <div class="item_body_button c-alertPos">
      <Button
        block
        fsize="f12"
        variant="main"
        @click="checkKeywordRank"
        :disabled="isProcessing"
        :class="{
          'is-loading': this.isProcessing
        }"
      >
        「成果チェック」で効果を見る
      </Button>
      <Alert v-if="request.error">
        {{ request.error }}
      </Alert>
    </div>
  </div>
</template>

<script>
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import { USAGE_LABEL, USAGE_COUNT_LABEL } from '@/constants';
import apiProjects from '@/api/projects';
import utils from '@/utils';

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    project: {
      type: Object,
      required: true
    }
  },

  components: {
    Alert,
    Button
  },

  created() {
    this.$store.dispatch('task/getTaskSolutions');
  },

  data() {
    return {
      request: {
        error: ''
      },
      isProcessing: false
    };
  },

  methods: {
    // 通知日（＝タスク完了日の1ヶ月先の日付）
    outputDate(target_date) {
      const value = new Date(target_date);
      value.setMonth(value.getMonth() + 1);

      let today = new Date();

      // demoサイトでは固定のデータを表示させる
      if (process.env.VUE_APP_ENV === 'demo') {
        today = new Date(process.env.VUE_APP_DEMO_DATE);
        today.setHours(9, 0, 0, 0);
      }

      const value_f = utils.getDateResetHours(value);
      const today_f = utils.getDateResetHours(today);

      // 通知日>今日の日付の場合は、今日の日付を表示（日付のみで比較）
      if (value_f > today_f) {
        return today;
      } else {
        return value;
      }
    },

    async checkKeywordRank(e) {
      this.isProcessing = true;
      this.request.error = '';
      const route = { name: 'siteImportantKeyword', query: {} };

      const params = {
        keyword: this.item.keyword,
        url: this.item.url
      };
      const keywordId = await apiProjects.observationKeywords.search
        .get(params, this.auth.idToken, this.project.id)
        .then(response => response.data.id)
        .catch(error => null);

      if (keywordId) {
        route.query.id = keywordId;
        this.next(route, e);
        return;
      }

      Promise.all([
        this.getUsages({
          items: 'observation-keywords'
        }),
        this.getUsagesCount({
          items: 'observation-keywords'
        })
      ])
        .then(response => {
          const usages = response[0].data.items[0]; //登録数
          const usagesCount = response[1].data; //登録回数
          const usagesRest = usages.max - usages.current;
          const usagesRestCount = usagesCount.max - usagesCount.current;

          if (usagesCount.current >= usagesCount.max) {
            this.request.error = `${USAGE_COUNT_LABEL['observation-keywords']}の上限に達しています。検索順位キーワード登録回数の上限は${usagesRestCount}件です。`;
          } else if (usages.current >= usages.max) {
            this.request.error = `${USAGE_LABEL['observation-keywords']}の上限に達しています。サイトに登録できるのは${usagesRest}件までです。`;
          }
          if (this.request.error) {
            this.isProcessing = false;
            return;
          }

          apiProjects.observationKeywords
            .post(params, this.auth.idToken, this.project.id)
            .then(response => {
              route.query.id = response.data.id;
              route.query.status = 'new';
              this.next(route, e);
            })
            .catch(error => {
              if (error.response.data) {
                this.request.error = error.response.data.errors[0].userMessage;
              }
              this.isProcessing = false;
            });
        })
        .catch(error => {
          this.isProcessing = false;
        });
    },
    getUsages(params) {
      return apiProjects.usages
        .get(params, this.auth.idToken, this.project.id)
        .catch(error => {
          if (error.response && error.response.data) {
            this.request.error = error.response.data.errors[0].userMessage;
          }
          throw error;
        });
    },
    getUsagesCount(params) {
      return apiProjects.usages.count
        .get(params, this.auth.idToken, this.project.id)
        .catch(error => {
          if (error.response && error.response.data) {
            this.request.error = error.response.data.errors[0].userMessage;
          }
          throw error;
        });
    },
    next(route, e) {
      // Ctrlキーを押しながらボタンをクリックした時は、別タブで開く
      if (e.ctrlKey) {
        const href = this.$router.resolve(route).href;
        window.open(href);
        this.isProcessing = false;
      } else {
        this.$router.push(route);
      }
    }
  },

  watch: {
    // エラーが発生したら3秒後にエラーメッセージを消す
    'request.error': {
      handler() {
        setTimeout(() => {
          this.request.error = '';
        }, 3000);
      }
    }
  }
};
</script>
